import React, {useEffect, useState} from "react";
import style from "./style.module.sass";
import Brightness7Icon from '@material-ui/icons/Brightness7';
import Brightness4Icon from '@material-ui/icons/Brightness4';
import Brightness3Icon from '@material-ui/icons/Brightness3'
import {useTheme} from "@material-ui/styles";
import {useSelector} from "react-redux";
import {useActions} from "../../../../utils/action-helper";
import {userSetTheme} from "../../../../actions";
import config from "../../../../config";
import { useTranslation } from "react-i18next"

function ThemeHandler() {
  const [isDisabled, setIsDisabled] = useState(false);
  const {theme: {bgColors, colors}} = useTheme()
  const {t} = useTranslation()
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT);

  const themes = config.themes
  const getNextTheme = (current) => {
    const index = themes.indexOf(current)
    return themes[(index + 1) % themes.length]
  }

  // bind actions
  const {actionUserSetTheme} = useActions({
    actionUserSetTheme: userSetTheme,
  })

  let ICON
  if (themeState === config.THEMES_MODES.LIGHT) {
    ICON = <Brightness7Icon color="primary"/>
  } else if (themeState === config.THEMES_MODES.CONTRAST_DARK) {
    ICON = <Brightness3Icon style={{color: colors.colorPrimary0}}/>
  } else {
    ICON = <Brightness4Icon color="action"/>
  }

  useEffect(() => {
    if (isDisabled) {
      setTimeout(() => {
        setIsDisabled(false)
      }, 400)
    }
  }, [isDisabled])

  const toggleTheme = () => {
    const nextTheme = getNextTheme(themeState)
    actionUserSetTheme(nextTheme)
    setIsDisabled(true)
  }

  return (
    <div tabIndex={config.tabIndexes.themeButton} onClick={toggleTheme} title={t('accessibility_header_toggle_theme')}>
      <button
        type="button"
        aria-label={t('accessibility_header_toggle_theme')}
        disabled={config.themeSwitchIsAlwaysDisabled || isDisabled}
        style={{ backgroundColor: bgColors.bgPrimary0 }}
        className={`${style.mainCont}`}>
        {ICON}
      </button>
    </div>
  )
}

export default ThemeHandler
